import { GridsterItem } from 'angular-gridster2';
import { GridStackNode } from 'gridstack/dist/types';

import { GridItemConfig } from '@recruitee/dashboard-types';

export const gridsterToGridstack = (widgetId: string, grid: GridsterItem): GridStackNode => ({
  x: grid.x,
  y: grid.y,
  w: grid.cols,
  h: grid.rows,
  minW: grid.minItemCols,
  minH: grid.minItemRows,
  maxW: grid.maxItemCols,
  maxH: grid.maxItemRows,
  id: widgetId,
});

export const gridstackToGridster = (grid: GridStackNode): GridsterItem => ({
  x: grid.x!,
  y: grid.y!,
  cols: grid.w!,
  rows: grid.h!,
  minItemCols: grid.minW,
  minItemRows: grid.minH,
  maxItemCols: grid.maxW,
  maxItemRows: grid.maxH,
});

export const gridItemConfigToGridstack = (grid: GridItemConfig) => ({
  w: grid.cols,
  h: grid.rows,
  minW: grid.minItemCols,
  minH: grid.minItemRows,
  maxW: grid.maxItemCols,
  maxH: grid.maxItemRows,
  locked: grid.locked,
  noMove: grid.noMove,
  noResize: grid.noResize,
});
